import React, { useId } from 'react';
import { INPUT, SUB_LABEL } from './styles';

/** From / to calendar dates (inclusive). Value: { from, to } as yyyy-mm-dd. */
const DateRangeRenderer = ({ field, value, onChange }) => {
    const id = useId();
    const v = value || {};
    const set = (end, next) => onChange({ ...v, [end]: next });
    return (
        <div className="grid grid-cols-2 gap-2">
            <div>
                <label htmlFor={`${id}-from`} className={SUB_LABEL}>
                    From
                </label>
                <input
                    id={`${id}-from`}
                    type="date"
                    value={v.from || ''}
                    max={v.to || undefined}
                    onChange={(e) => set('from', e.target.value)}
                    aria-label={`${field.label} from`}
                    className={INPUT}
                />
            </div>
            <div>
                <label htmlFor={`${id}-to`} className={SUB_LABEL}>
                    To
                </label>
                <input
                    id={`${id}-to`}
                    type="date"
                    value={v.to || ''}
                    min={v.from || undefined}
                    onChange={(e) => set('to', e.target.value)}
                    aria-label={`${field.label} to`}
                    className={INPUT}
                />
            </div>
        </div>
    );
};

export default DateRangeRenderer;
